import { render, staticRenderFns } from "./HistoryModule.vue?vue&type=template&id=46948639"
import script from "./HistoryModule.vue?vue&type=script&lang=js"
export * from "./HistoryModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports